import React from "react";
import PropTypes from "prop-types";

const StepPanel = ({ number, title, complete, locked, lockedHint, summary, children }) => (
  <section className={["series-step-panel", locked ? "locked" : ""].join(" ").trim()}>
    <header className="series-step-panel-header">
      <span
        className={["series-step-badge", complete ? "complete" : locked ? "" : "active"]
          .join(" ")
          .trim()}
      >
        {complete ? <i className="fas fa-check" aria-hidden="true" /> : number}
      </span>
      <h3 className="series-step-panel-title">{title}</h3>
      {locked && lockedHint && <span className="series-step-panel-hint">{lockedHint}</span>}
      {!locked && summary && <span className="series-step-panel-hint">{summary}</span>}
    </header>
    {!locked && <div className="series-step-panel-body">{children}</div>}
  </section>
);

StepPanel.propTypes = {
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  complete: PropTypes.bool,
  locked: PropTypes.bool,
  lockedHint: PropTypes.string,
  summary: PropTypes.string,
  children: PropTypes.node,
};

export default StepPanel;
